import { createApp } from 'vue'

import App from '@/App.vue'
import { useAuth } from '@/composables/useAuth'
import { router } from '@/plugins/router'
import { registerPlugins } from '@core/utils/plugins'

// Styles
import '@core/scss/template/index.scss'
import '@layouts/styles/index.scss'

async function bootstrap() {
  await useAuth().configure()
  const app = createApp(App)
  registerPlugins(app, router)
  app.mount('#app')
}

bootstrap()
